import { render, staticRenderFns } from "./TireDialogTabs.vue?vue&type=template&id=8ee00dea&"
import script from "./TireDialogTabs.vue?vue&type=script&lang=js&"
export * from "./TireDialogTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports